import React from 'react'
import cx from 'classnames'
import { useDispatch } from 'react-redux'
import WhatsappLineIcon from 'remixicon-react/WhatsappLineIcon'
import CustomerServiceLineIcon from 'remixicon-react/CustomerServiceLineIcon'
import { rootActions } from '@app-store/slices'
import { whatsappNumberSupport } from '@features/General/constants'
import styles from './index.scss'

interface Props {
    isStepLayout?: boolean
}
const FloatingIcons = ({ isStepLayout }: Props) => {
    const dispatch = useDispatch()
    return (
        <div className={cx(styles.container, { [styles['step-layout']]: isStepLayout })}>
            <span
                onClick={() => window.open(`https://wa.me/${whatsappNumberSupport}`, '_blank', 'noopener,noreferrer')}
            >
                <WhatsappLineIcon size={32} />
            </span>
            <span className={styles.support}>
                <CustomerServiceLineIcon
                    size={32}
                    onClick={() =>
                        dispatch(
                            rootActions.ui.common.onChangeItems({
                                supportModalVisible: true,
                                userMenuVisible: false
                            })
                        )
                    }
                />
            </span>
        </div>
    )
}

export default FloatingIcons
